import React, { useState, useEffect } from "react"
import { useUpdateCheck } from "react-update-notification"
import { Button, Toast, ToastContainer } from "react-bootstrap"

const UpdateNotification = () => {
  // Add a state to track if we've done the initial check
  const [initialCheckDone, setInitialCheckDone] = useState(() => {
    return localStorage.getItem("updateCheckTimestamp") !== null
  })

  // Only perform checks periodically, not on every mount
  const { status, reloadPage, checkUpdate } = useUpdateCheck({
    type: initialCheckDone ? "manual" : "mount",
    interval: 60000 // Not used when type is manual or mount
  })

  // When an update is detected and the page is reloaded, clear the version from localStorage
  // so the Footer will fetch the new version
  const handleReload = () => {
    localStorage.removeItem("appVersion")
    localStorage.removeItem("updateCheckTimestamp")
    reloadPage()
  }

  // Set up our own periodic check using useEffect instead of the built-in interval
  useEffect(() => {
    const now = Date.now()
    const lastCheck = parseInt(localStorage.getItem("updateCheckTimestamp") || "0", 10)
    const checkInterval = 60 * 1000 // 1 minute

    // Check if we need to perform a check (if 1 minuute has passed since last check)
    if (now - lastCheck > checkInterval) {
      checkUpdate()
      localStorage.setItem("updateCheckTimestamp", now.toString())
      setInitialCheckDone(true)
    }

    // Set up interval for future checks
    const intervalId = setInterval(() => {
      checkUpdate()
      localStorage.setItem("updateCheckTimestamp", Date.now().toString())
    }, checkInterval)

    return () => clearInterval(intervalId)
  }, [checkUpdate])

  if (status !== "available") {
    return null
  }

  return (
    <ToastContainer position="bottom-center" className="p-3 update-notification" style={{ zIndex: 9999 }}>
      <Toast show={true}>
        <Toast.Header>
          <strong className="m-auto">Ενημέρωση</strong>
        </Toast.Header>
        <Toast.Body className="text-center">
          <p>Είναι διαθέσιμη νέα έκδοση του eExpert.</p>
          <p>
            Παρακαλούμε ολοκληρώστε την τρέχουσα εργασία σας και επαναφορτώστε τη σελίδα, πατώντας το ακόλουθο
            κουμπί.
          </p>
          <Button variant="primary" onClick={handleReload}>
            Επαναφόρτωση
          </Button>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  )
}

export default UpdateNotification
